<template>
    <div class="ui-loader">
        <div class="ui-loader__indicator"></div>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
    @use 'UILoader' as *;
</style>
